import images from 'assets/images';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const PaymentRedirect = () => {
    useEffect(() => {
        const baseURL = window.location.href.replace('/portal', '');
        window.location.href = baseURL;
    }, []);
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>InstaVolt - Rapid EV Charging UK</title>
                <meta property="og:url" content={window.location.origin} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="instavolt" />
            </Helmet>
            <div className="card-body text-center" style={{ width: '100%', background: 'white', height: '100vh' }}>
                <div className="row min-vh-50 align-items-center">
                    <div className="col">
                        <div className="mesg-box process-block text-center">
                            <img src={images.processGIF} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PaymentRedirect;
